import React from 'react';
import {
  IconButton,
  Tooltip,
} from '@mui/material';
import {
  Share as ShareIcon,
} from '@mui/icons-material';
import { shareToPlatform, isSocialMediaPlatform, SocialShareOptions } from '../../../utils/socialShare';

interface SocialShareButtonProps {
  platformName: string;
  content: string;
  url?: string;
  size?: 'small' | 'medium' | 'large';
}

export const SocialShareButton: React.FC<SocialShareButtonProps> = ({
  platformName,
  content,
  url = '',
  size = 'small',
}) => {
  // Only show share button for social media platforms (not email/blog)
  if (!isSocialMediaPlatform(platformName)) {
    return null;
  }

  const handleShare = async (event: React.MouseEvent) => {
    event.stopPropagation();
    const options: SocialShareOptions = {
      text: content,
      url: url || window.location.href,
    };
    await shareToPlatform(platformName, options);
  };

  return (
    <Tooltip title={`Share on ${platformName.charAt(0).toUpperCase() + platformName.slice(1)}`}>
      <IconButton
        size={size}
        onClick={handleShare}
        sx={{
          '&:hover': {
            backgroundColor: 'action.hover',
          },
        }}
      >
        <ShareIcon />
      </IconButton>
    </Tooltip>
  );
};

